/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RdSAPFloorDimensionsV0 { 
    /**
     * The identifier for the building part to which these floor dimensions belong.
     */
    readonly buildingPartId?: number;
    /**
     * The type or identifier of the floor.
     */
    floor?: string;
    /**
     * The construction type of the floor.
     */
    floorConstruction?: string;
    /**
     * The insulation type used in the floor.
     */
    floorInsulation?: string;
    /**
     * The total area of the floor.
     */
    area?: number;
    /**
     * The height of the room, if applicable.
     */
    height?: number;
    /**
     * The heat loss perimeter of the floor.
     */
    perimeter?: number;
    /**
     * The length of the party wall adjoining the floor.
     */
    partyWall?: number;
}

